import { useEffect, useState } from 'react';
import { useFeatureValue } from '@growthbook/growthbook-react';
import { useExperiment } from '../context/AnalyticsContext';

function getValue(featureValue, overrideFeatureFlagValue, defaultValue) {
  if (overrideFeatureFlagValue !== null) {
    if (typeof featureValue === 'boolean') {
      if (overrideFeatureFlagValue === 'true') {
        return true;
      }
      if (overrideFeatureFlagValue === 'false') {
        return false;
      }
      return defaultValue ?? null;
    }
    return overrideFeatureFlagValue;
  }

  if (featureValue != null && featureValue !== '') {
    return featureValue;
  }

  return defaultValue ?? null;
}

const useFeatureFlagValue = (featureFlag: string, defaultValue: any) => {
  const gbFeatureValue = useFeatureValue(featureFlag, null);

  const experiment = useExperiment();
  const formattedFeatureFlag = featureFlag.split(':').join('-');

  const ampFeatureValue = experiment.variant(formattedFeatureFlag);

  const ampPayload = ampFeatureValue?.payload;
  const normalizedAmpValue =
    typeof ampFeatureValue?.value === 'string'
      ? (() => {
          const value = ampFeatureValue.value.toLowerCase();
          if (['on', 'true'].includes(value)) {
            return true;
          }
          if (['off', 'false'].includes(value)) {
            return false;
          }
          return ampFeatureValue.value;
        })()
      : ampFeatureValue?.value;
  const ampValue = normalizedAmpValue ?? defaultValue;

  let featureValue = gbFeatureValue;
  if (featureValue == null || featureValue === '') {
    featureValue = ampPayload ?? ampValue;
  }

  // Read the query override after mount. `window` is unavailable during SSR, so reading it during render hydrates a different experiment branch than the server sent.
  const [overrideFeatureFlagValue, setOverrideFeatureFlagValue] = useState<string | null>(null);

  useEffect(() => {
    setOverrideFeatureFlagValue(new URLSearchParams(window.location.search).get(featureFlag));
  }, [featureFlag]);

  return getValue(featureValue, overrideFeatureFlagValue, defaultValue);
};

export default useFeatureFlagValue;
